<template>
  <div>
    <button
      type="button"
      class="btn btn-default btn-form-group p-2 mb-3"
      @click="addNewPackageBtn"
    >
      Add New Package
    </button>

    <product-package
      v-for="(productPackage, index) in productPackages"
      :key="productPackage.id"
      v-model="productPackages[index]"
      :index="productPackage.id"
      :is-dialog-view="false"
      :products="products"
      :value="productPackage"
      @remove-package="removePackage"
      @save-package="savePackage"
    />

    <v-dialog
      v-model="isAddPackageModalOpen"
      max-width="1140px"
    >
      <v-card>
        <template #title>
          New package
        </template>
        <v-divider />
        <div class="px-3 pb-4">
          <product-package
            v-model="newPackage"
            :is-dialog-view="true"
            :products="products"
            :value="newPackage"
            @add-package="addPackage"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
  <v-snackbar
    v-model="isSnackbarOpen"
    :timeout="3000"
    location="top right"
  >
    <v-alert
      color="#dfe8e8"
      :title="title"
      :text="message"
    />
  </v-snackbar>
</template>

<script>
import { lookup } from '../lookup/lookup';
import ProductPackage from './productPackage.vue';
import { toCurrency } from '../../helpers/currency';

export default {
  components: { ProductPackage },
  data() {
    return {
      newPackage: null,
      productPackages: [],
      products: [],
      isAddPackageModalOpen: false,
      isSnackbarOpen: false,
      message: '',
      title: '',
    };
  },

  async mounted() {
    const [packages, products] = await Promise.all([
      lookup.computed.packages(),
      lookup.computed.products(),
    ]);
    this.productPackages = packages;
    this.products = products;
    this.products.map(
      el => (el.name = `${el.name} (${toCurrency(el.unit_price)})`),
    );
  },
  methods: {
    addNewPackageBtn() {
      this.newPackage = {
        name: '',
        class_category_id: 1000,
        expenses_description: '',
        expenses_amount: null,
        included_products: [],
        optional_products: [],
        package_discounts: [],
        states: [],
      };
      this.isAddPackageModalOpen = true;
    },
    addPackage(productPackage) {
      this.productPackages.unshift(productPackage);
      this.isAddPackageModalOpen = false;

      this.openSnackbar('Added', productPackage.name);
    },
    savePackage(productPackage) {
      this.openSnackbar('Saved', productPackage.name);
    },
    removePackage(productPackage) {
      this.productPackages.splice(
        this.productPackages.findIndex(item => item.id === productPackage.id),
        1,
      );

      this.openSnackbar('Deleted', productPackage.name);
    },

    openSnackbar(title, message) {
      this.isSnackbarOpen = true;
      this.title = title;
      this.message = message;
    },
  },
};
</script>
